import React from "react";
import { PROJECTS } from "@/data/portfolio";

export const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="bg-background"
    >
      <div className="max-w-3xl mx-auto px-6 py-10">
        <hr className="rule" />
        <h2 className="font-serif text-2xl md:text-3xl text-foreground mb-2">
          Projects
        </h2>
        <p className="text-sm text-quiet mb-8">
          A few things I've built outside of work &mdash; mostly open source.
        </p>

        <div className="space-y-10">
          {PROJECTS.map((p) => (
            <article key={p.name} data-testid={p.testid}>
              <h3 className="font-serif text-xl md:text-2xl text-foreground">
                <a
                  href={p.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  {p.name}
                </a>
                <span className="text-quiet font-body text-sm font-normal italic ml-2">
                  &mdash; {p.type}
                </span>
              </h3>
              <p className="mt-2 text-base text-foreground/85 leading-relaxed">
                <strong className="font-medium">{p.tagline}</strong>
              </p>
              <p className="mt-2 text-base text-foreground/80 leading-relaxed">
                {p.description}
              </p>
              <p className="mt-3 text-sm text-quiet">
                <span className="small-caps">Stack:</span>{" "}
                {p.stack.join(" · ")}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-10 text-sm text-quiet">
          More on{" "}
          <a
            href="https://github.com/ashraf-0907"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="see-more-github"
            className="link"
          >
            GitHub →
          </a>
        </p>
      </div>
    </section>
  );
};
